<div class="title-link-save">
  <div class="title-and-need-help">
    <h1 class="main-title">Configure Official Enrollment Rules</h1>
    <a
      href="https://community.schoolzilla.com/t/data-configuration-settings/1944"
      target="_blank"
      class="need-help-link"
      title="Open help page in new tab"
      >Need help?</a
    >
  </div>
  <div class="save-btn-div">
    <button
      mat-raised-button
      [disabled]="
        jobStatusService.hasMinDaysInputError ||
        jobStatusService.hasEnrollmentWindowInputError()
      "
      (click)="saveChanges($event.target, 'SAVE IN PROGRESS')"
      class="save-btn green-btn"
      *ngIf="showSaveChangesBtn()"
    >
      SAVE CHANGES
    </button>
    <p
      class="invalid-input-text"
      *ngIf="
        jobStatusService.hasMinDaysInputError ||
        jobStatusService.hasEnrollmentWindowInputError()
      "
    >
      Please resolve errors before saving!
    </p>
  </div>
</div>
<div class="description">
  <p>
    Specify the enrollment criteria that a student must meet to be included in a
    starting cohort. Also, indicate preferences for including No Shows in the
    data warehouse. Please contact support if you have questions.
  </p>
</div>
<div class="minimumDaysEnrolled">
  <official-enrollment-rules-panel
    [panelType]="'minDaysEnrolled'"
    [titleAndDesc]="titlesAndDescriptions['minDaysEnrolled']"
  ></official-enrollment-rules-panel>
</div>
<div class="enrollmentWindows">
  <official-enrollment-rules-panel
    [panelType]="'enrollmentWindows'"
    [titleAndDesc]="titlesAndDescriptions['enrollmentWindows']"
  ></official-enrollment-rules-panel>
</div>
<div class="noShows">
  <official-enrollment-rules-panel
    [panelType]="'noShows'"
    [titleAndDesc]="titlesAndDescriptions['noShows']"
  ></official-enrollment-rules-panel>
</div>
